import { MapPin } from "lucide-react";
import { cn } from "@/lib/utils";
import { serviceAreas, serviceAreaIntro, business } from "@/data/siteConfig";
import { SectionHeader } from "@/components/SectionHeader";
import { CallButton } from "@/components/CallButton";
import { Reveal } from "@/components/Reveal";

export const ServiceAreaPreview = () => (
  <section className="grain relative bg-ink py-24 md:py-32" data-testid="service-area-preview">
    <div className="relative z-10 mx-auto max-w-[1440px] px-5 md:px-8">
      <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <SectionHeader
            overline="Service Area"
            title={`Based in ${business.city}, serving Southern California`}
            description={serviceAreaIntro}
          />
          <div className="mt-8">
            <CallButton size="lg" showNumber testid="area-call-btn" />
          </div>
        </div>

        <Reveal>
          <div className="border border-white/10 bg-ink-surface p-8">
            <div className="mb-6 flex items-center gap-2 font-heading text-xs font-bold uppercase tracking-[0.2em] text-gold">
              <MapPin className="h-4 w-4" /> Communities we serve
            </div>
            <div className="flex flex-wrap gap-2.5">
              {serviceAreas.map((c) => (
                <span
                  key={c}
                  className={cn(
                    "rounded-sm border px-3 py-1.5 text-sm transition-colors duration-200",
                    c === business.city
                      ? "border-gold bg-gold/10 font-bold text-gold"
                      : "border-white/10 text-steel-light hover:border-white/25",
                  )}
                >
                  {c}
                </span>
              ))}
              <span className="rounded-sm border border-dashed border-white/15 px-3 py-1.5 text-sm text-steel/70">
                + surrounding areas
              </span>
            </div>
            <p className="mt-6 text-xs leading-relaxed text-steel/70">
              Service availability can vary by job. Please call to confirm we can reach
              your location and project.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
